import { render, staticRenderFns } from "./21.vue?vue&type=template&id=20798f8a&scoped=true&"
import script from "./21.vue?vue&type=script&lang=js&"
export * from "./21.vue?vue&type=script&lang=js&"
import style0 from "./21.vue?vue&type=style&index=0&id=20798f8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20798f8a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20798f8a')) {
      api.createRecord('20798f8a', component.options)
    } else {
      api.reload('20798f8a', component.options)
    }
    module.hot.accept("./21.vue?vue&type=template&id=20798f8a&scoped=true&", function () {
      api.rerender('20798f8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/product/details/21.vue"
export default component.exports